import { NgModule } from '@angular/core'

import { ActioncableApi } from './actioncable'
import { AuthApi, ICredential, ILoginResponse } from './auth'
import { AreaApi } from './area/base'
import { EventApi } from './event/base'
import { LectureApiBase } from './lecture-api'
import { LectureApi } from './lecture'
import { UserApi } from './user'
import { PlayHistoryApi } from './play-history/base'
import { PlayCountApi } from './play-count/base'
import { YoutubeOEmbed, YoutubeOEmbedApi } from './youtube-oembed'
import { VideoApi } from './video'
import { SharingGroupApi } from './sharing-group'
import { PlaySessionApi } from './play-session'
import { YouTubeCaptionApi } from './youtube-caption'
import { StaticContentApi } from './static-content'
import { DirectUploadApi } from './direct-upload'
import { VideoAreaApi } from './area/video'
import { StaticContentAreaApi } from './area/static-content'
import { VideoEventApi } from './event/video'
import { StaticContentEventApi } from './event/static-content'
import { VideoPlayHistoryApi } from './play-history/video'
import { StaticContentPlayHistoryApi } from './play-history/static-content'
import { VideoPlayCountApi } from './play-count/video'
import { StaticContentPlayCountApi } from './play-count/static-content'
import { NhkDetailApi } from './nhk-detail'
import { ReplyApi } from './reply'

@NgModule({
  providers: [
    ActioncableApi,
    LectureApiBase,
    AuthApi,
    VideoAreaApi,
    StaticContentAreaApi,
    VideoEventApi,
    StaticContentEventApi,
    LectureApi,
    UserApi,
    VideoPlayHistoryApi,
    StaticContentPlayHistoryApi,
    VideoPlayCountApi,
    StaticContentPlayCountApi,
    YoutubeOEmbedApi,
    VideoApi,
    SharingGroupApi,
    PlaySessionApi,
    YouTubeCaptionApi,
    StaticContentApi,
    DirectUploadApi,
    NhkDetailApi,
    ReplyApi,
  ],
})
export class ApisModule { }

export {
  ActioncableApi,
  LectureApiBase,
  AuthApi,
  AreaApi,
  ICredential,
  ILoginResponse,
  EventApi,
  LectureApi,
  UserApi,
  PlayHistoryApi,
  PlayCountApi,
  YoutubeOEmbed,
  YoutubeOEmbedApi,
  VideoApi,
  SharingGroupApi,
  PlaySessionApi,
  YouTubeCaptionApi,
  StaticContentApi,
  DirectUploadApi,
  VideoPlayHistoryApi,
  VideoAreaApi,
  VideoEventApi,
  StaticContentPlayHistoryApi,
  StaticContentEventApi,
  StaticContentAreaApi,
  VideoPlayCountApi,
  StaticContentPlayCountApi,
  NhkDetailApi,
  ReplyApi,
}



// WEBPACK FOOTER //
// ./src/apis/index.ts